"use client";

import { useEffect } from "react";

// Marketing page not snapshotted into public/folktale-ai/. Client-side redirect
// to the live page on folktale.ai. Served as a normal 200 HTML page, so there's
// no cached redirect status that can get stuck failing at a CDN edge (unlike a
// server 307). window.location.replace avoids a back-button trap; the meta
// refresh covers no-JS, and the link is a manual fallback.
const TARGET = "https://folktale.ai/is-folktale-right-for-me";

export default function IsFolktaleRightForMePage() {
  useEffect(() => {
    window.location.replace(TARGET);
  }, []);

  return (
    <>
      {/* React 19 hoists this to <head>; redirects even when JS is disabled. */}
      <meta httpEquiv="refresh" content={`0; url=${TARGET}`} />
      <p style={{ fontFamily: "system-ui, sans-serif", padding: "2rem" }}></p>
    </>
  );
}
